import { z } from 'zod';
import { GetApprovalResponseSchema } from '../get-approval/get-approval.schema';
/**
 * Override Approval
 * POST /api/v2/approval/:id/override — an admin lets the step run without
 * the reviewers, with a reason. Stand-in until deputies exist (plan 053).
 */ export const OverrideApprovalRequestSchema = z.object({
    reason: z.string().trim().min(1).max(2000)
});
export const OverrideApprovalResponseSchema = GetApprovalResponseSchema;

//# sourceMappingURL=override-approval.schema.js.map